import {ApolloLink} from '@apollo/client';

export default function createExtensionsLink() {
  return new ApolloLink(function extensionsLink(operation, forward) {
    return forward(operation).map(function extensionsLinkResponse(result) {
      if (result.data) {
        result.data._extensions = result.extensions;
      }

      return result;
    });
  });
}
